import { render, staticRenderFns } from "./TopControls.vue?vue&type=template&id=2bc1d2bb&scoped=true&"
import script from "./TopControls.vue?vue&type=script&lang=js&"
export * from "./TopControls.vue?vue&type=script&lang=js&"
import style0 from "./TopControls.vue?vue&type=style&index=0&id=2bc1d2bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1d2bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VRow,VSwitch,VTooltip})
